import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { LoyaltyResponseModel } from '@/types'

export const getLoyaltyMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<LoyaltyResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/loyalty`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
